import { parseJsonRecord } from '@federa/const/attribute-bag-readers';
import { isPlainObject } from '@federa/const/record-guards';

/** Parse a JSON string into a record; `null` for an empty string, a parse failure or a scalar payload. Large integers are preserved. */
function parseRecordJson(value: string): Record<string, unknown> | null {
	if (value === '') return null;
	return parseJsonRecord(value, true);
}

export function coerceRecord(value: unknown): Record<string, unknown> | null {
	if (isPlainObject(value)) {
		return value;
	}
	if (typeof value !== 'string') {
		return null;
	}
	return parseRecordJson(value);
}

/** Resolve a flow/tool handler's env from the `(config, adapterContext, envArg)` task-node convention: the adapter
 * context's `env` wins, then the third-arg fallback, then `{}`. The shared prologue of every handler binding host env
 * off that contract; a handler with no third parameter simply omits `envArg`. */
export function resolveHandlerEnv(context?: unknown, envArg?: Record<string, unknown>): Record<string, unknown> {
	return coerceRecord(coerceRecord(context)?.env) ?? envArg ?? {};
}

/** Narrow an `unknown[]` into a typed array via per-record projection; `project` returns `null` to drop a row, and a non-array `raw` yields `[]`. */
export function narrowObjectArray<T>(raw: unknown, project: (record: Record<string, unknown>) => T | null): T[] {
	if (!Array.isArray(raw)) return [];
	const out: T[] = [];
	for (const item of raw) {
		const record = coerceRecord(item);
		if (!record) continue;
		const projected = project(record);
		if (projected === null) continue;
		out.push(projected);
	}
	return out;
}
